//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {RemainingTime} from '@/components';

export default {
  name: 'order-status-box',
  components: {
    RemainingTime,
  },
  props: {
    status: {
      type: Number | String,
      default: 0,
    },
    statusStr: {
      type: String,
      default: '',
    },
    targetTime: {
      type: String,
      default: '',
    },
    remainTime: {
      type: Number | String,
      default: 0,
    },
    processingMsg: {
      type: String,
      default: '',
    },
    processingCheckInMsg: {
      type: String,
      default: '',
    },
  },
  data(){
    return {
      bgClass: '',
      flagImgUrl: '',
      isShowStep: false,
      isShowSettleTips: false,
    };
  },
  watch: {
    status(cur){
      this.init();
    },
  },
  methods: {
    init(){
      const status = Number(this.status);

      switch (status){
        case 1:
          this.bgClass = 'bg-red';
          this.flagImgUrl = '/m/static/images/orders/icon-clock-white@2x.png';
          break;
        case 2:
          this.bgClass = 'bg-green';
          this.flagImgUrl = '/m/static/images/orders/icon-clock-white@2x.png';
          break;
        case 3:
          this.bgClass = 'bg-green';
          this.flagImgUrl = '/m/static/images/orders/icon-checked-white@2x.png';
          break;
        case 4:
          this.bgClass = 'bg-green';
          this.flagImgUrl = '/m/static/images/orders/icon-tips-white@2x.png';
          break;
        case 5:
          this.bgClass = 'bg-grey';
          this.flagImgUrl = '/m/static/images/orders/icon-checked-white@2x.png';
          break;
        case 6:
          this.bgClass = 'bg-green';
          this.flagImgUrl = '/m/static/images/orders/icon-checked-white@2x.png';
          break;
        default: break;
      }
    },

    onRemainingEnd(){
      this.$emit('on-remain-end');
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/order/components/OrderStatusBox.vue